import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatFlashbar = createCustomElementWrapper('kat-flashbar', 'KatFlashbar', {
    'linkHref': 'link-href',
    'linkLabel': 'link-label',
    'linkPreventDefault': 'link-prevent-default',
    'linkTarget': 'link-target',
}, {
    'onDismissed': 'dismissed',
    'onLinkClick': 'link-click',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/flashbar.js
// module id = 1265
// module chunks = 0